export const statuses = [
	{ name: "Resident", icon: "bi-house-door" },
	{ name: "Tourist", icon: "bi-airplane-engines" },
	{ name: "Student", icon: "bi-person-badge" },
	{ name: "Digital Nomad", icon: "bi-laptop" },
];

export const getStatusIcon = (status) => {
	switch (status) {
		case "Resident":
			return <i className="bi bi-house-door"></i>;
		case "Tourist":
			return <i className="bi bi-airplane"></i>;
		case "Student":
			return <i className="bi bi-book"></i>;
		case "Digital Nomad":
			return <i className="bi bi-laptop"></i>;
		default:
			return null;
	}
};
